
import { SxProps, useTheme, Typography, Button } from "@mui/material";
import { styled } from '@mui/system';
import { StyleguideSavioFonts } from "../../../site/configuration/themeSettings";

interface MyStyledTypografyProps {
  compact?: boolean;
}

export const StyledTypography = styled(Typography, { label: "AppLayout-root" })<MyStyledTypografyProps>
  (({ compact, theme }) => ({
    // textAlign: "justify",
    borderRadius: 6,
    fontSize: 14,
    fontWeight: StyleguideSavioFonts.normal,
    padding: "10px !important",
    backgroundColor: "#fff",
    color: "#141414 !important",
    lineHeight: (compact ? "1.2" : "unset")
  }));

